import React from 'react';
import styles from './navBarItem.module.css';

export default ({ item, index, showWhat, setShowWhat }: { item: string; index: number; showWhat: number; setShowWhat: Function }) => {
  function style() {
    if (showWhat === index + 1) {
      return { textDecoration: 'underline' };
    } else {
      return {};
    }
  }

  return (
    <>
      <div
        className={styles.navBarItem}
        style={style()}
        onClick={() => {
          setShowWhat(index + 1);
        }}
      >
        {item}
      </div>
    </>
  );
};
